import React, { useEffect, useState } from "react";
import Header from "../../components/Shared/Header";
import backIcon from "../../assets/icons/backIcon.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ClientInfo from "../../components/Client/ClientInfo";
import { getClientInfo } from "../../Utils/client/client";
import Loading from "../../components/Shared/Loading";

const CustomerCardPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const param = useParams();
  const [loading, setLoading] = useState(false);

  const [clientInfo, setClientInfo] = useState(null);

  const getClientDetail = async () => {
    setLoading(true);
    try {
      const res = await getClientInfo(param.clientId);
      if (!res.data.user) {
        navigate("/admin/client/all");
        return;
      }
      setClientInfo(res.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  useEffect(() => {
      getClientDetail();
  }, []);

  return (
    <>
      {loading && <Loading />}
      <div className="bg-white h-full">
        <Header title="Fiche client " />
        <div className="h-[calc(100%-100px)]">
          <Link
            to="/admin/client/all"
            className="cursor-pointer flex pl-5 gap-2 mt-8"
          >
            <img src={backIcon} alt="" className="w-5" />{" "}
            <div className="font-semibold text-base text-indigo-600">
              {" "}
              Retour
            </div>
          </Link>
          <div className="h-[calc(100%-25px)] ">
            {clientInfo && <ClientInfo clientInfo={clientInfo} />}{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerCardPage;
